import "./Start.module.css";
import Naglowek from "@/reusable_sections/Header";
import TreningPrzygodaWTajlandii from "./sections/TreningPrzygodaWTajlandii";
import NewWaveCampKohSamui2026 from "./sections/NewWaveCampKohSamui2026";
import EksperckaKadraIKlimatKohSamui from "./sections/EksperckaKadraIKlimatKohSamui";
import PlanBojowy12Dni from "./sections/PlanBojowy12Dni";
import KluczoweInformacje from "./sections/KluczoweInformacje";
import RajskieWyspy from "./sections/RajskieWyspy";
import ZarezerwujSwojeMiejsce from "./sections/ZarezerwujSwojeMiejsce";
import Faq from "./sections/Faq";
import Kontakt from "@/reusable_sections/Footer";
export default function StartPage() {
  return <div>
      <Naglowek />
      <TreningPrzygodaWTajlandii />
      <NewWaveCampKohSamui2026 />
      <EksperckaKadraIKlimatKohSamui />
      <PlanBojowy12Dni />
      <KluczoweInformacje />
      <RajskieWyspy />
      <ZarezerwujSwojeMiejsce />
      <Faq />
      <Kontakt />
    </div>;
}